import { Api } from "../axios.config";

const path = "/definitions";

export const getBehaviorDefinitions = (type = "BotTwitter") =>
  Api.get(`${path}/behaviors?type=${type}`);
